<div class="courses-area pt-20 pb-70">
  <div class="container">
    <div class="section-title">
      <!-- <span class="sub-title">POPULAR courses</span> -->


      <h2>La formation comprend 4 niveaux</h2>
      <p>Explorez l’ensemble des niveaux d'étude et rejoignez-nous ! </p>
    </div>
    <div class="row justify-content-center">



      <div *ngFor="let item of items" class="card col-lg-8 mx-auto my-5 p-2" style="max-width: 32rem;">
        <div class="card-body d-flex flex-row">

          <div class="level-title">
            <h5 class="card-title font-weight-bold mb-2"><span>{{item.level}}</span></h5>
          </div>
        </div>
        <div class="bg-image hover-overlay ripple rounded-0" data-mdb-ripple-color="light">
          <img class="img-fluid" [src]="item.picture" alt="Card image cap" />
          <a href="#!">
            <div class="mask" style="background-color: rgba(251, 251, 251, 0.15);"></div>
          </a>
        </div>
        <div class="card-body">
          <p [ngbCollapse]="item.isCollapsed">
            {{item.description}}
          </p>

          <div class="d-flex justify-content-between">
            <a style="margin-top: -1px !important;
                        color: #9b215c!important;" class="btn btn-link link-danger p-md-1 my-1"
              (click)="item.isCollapsed = !item.isCollapsed" data-toggle="collapse" href="javascript:void(0)"
              role="button" aria-expanded="false" aria-controls="collapseExample">
              <span *ngIf="item.isCollapsed">En savoir plus</span><span *ngIf="!item.isCollapsed">Reduire</span></a>
            <div style="margin: 5px;
            border: solid #ffc107 2px;
            padding: 3px;border-right: 0;    border-left: 0;
    border-bottom: 0;">
              <i class="fas fa-graduation-cap pe-2"></i><span class="font-weight-bold "> {{item.courses}} cours</span>
            </div>
          </div>
        </div>
      </div>